import { render, staticRenderFns } from "./followLogTypeSet.vue?vue&type=template&id=67e5c76d&scoped=true&"
import script from "./followLogTypeSet.vue?vue&type=script&lang=js&"
export * from "./followLogTypeSet.vue?vue&type=script&lang=js&"
import style0 from "./followLogTypeSet.vue?vue&type=style&index=0&id=67e5c76d&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e5c76d",
  null
  
)

export default component.exports